/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedirectResponse
 */
export interface RedirectResponse {
    /**
     * 
     * @type {string}
     * @memberof RedirectResponse
     */
    redirect?: string | null;
}

export function RedirectResponseFromJSON(json: any): RedirectResponse {
    return RedirectResponseFromJSONTyped(json, false);
}

export function RedirectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedirectResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'redirect': !exists(json, 'redirect') ? undefined : json['redirect'],
    };
}

export function RedirectResponseToJSON(value?: RedirectResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'redirect': value.redirect,
    };
}


